import {Component, DestroyRef, effect, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatDialog} from '@angular/material/dialog';
import {KtCogsFilterService} from '../service/kt-cogs-filter.service';
import {KtCogsFilterModalComponent} from '../components/kt-cogs-filter-modal/kt-cogs-filter-modal.component';

@Component({
  selector: 'app-kt-cogs',
  templateUrl: './kt-cogs.component.html',
  standalone: false,
})
export class KtCogsComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);
  private readonly filterService = inject(KtCogsFilterService);

  constructor() {
    effect(() => {
      const open = this.filterService.toggleModal();
      if (!open) return;
      const d = this.dialog.open(KtCogsFilterModalComponent, {width: '700px'});
      d.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.filterService.toggleModal.set(false);
      });
    });
  }
}
